// @ts-nocheck
import formatDate from "includes/formatDate";
import genRequest from "includes/request";
import generateUUID from "includes/UUID";
import FormQuestionModel from "./FormQuestionModel";

export default class FormSectionModel {

	constructor(obj, parent) {

		let date = formatDate();
		this.parent = parent;
		this.formSectionId = (obj?.formSectionId || obj?.id || null);
		this.formId = (obj?.formId || null);
		this.tempId = generateUUID();
		this.title = (obj?.title || "");
		this.txt = (obj?.txt || "");
		this.position = (obj?.position != null ? obj.position : null);
		this.requiered = (obj?.requiered || false);
		this.lastChanged = (obj?.lastChanged || date);
		this.lastChangedAuthorId = (obj?.lastChangedAuthorId || null);
		this.questions_ = [];

		if (obj?.questions) {
			for (let question of obj.questions)
				this.questions_.push(new FormQuestionModel(question, this));
		}
	}

	send() {
		let that = this;
		let prom = new Promise((resolve, reject) => {
			this.sendSection()
				.then(() => {
					that.sendQuestions(true);
				}, reject)
				.then(resolve, reject);
		});
		return (prom);
	}

	sendSection() {
		let that = this;
		let req = genRequest(
			"forms/sections" + (this.formSectionId ? "/" + this.formSectionId : ""),
			this.values(),
			(this.formSectionId ? "put" : "post")
		)
			.then((resp) => {
				if (!that.formSectionId)
					that.id = resp.id || resp.formSectionId;
			});
		return (req);
	}

	sendQuestions() {
		let proms = this.questions_.map((a) => a.send());
		return (Promise.all(proms));
	}

	addQuestion(quest, index) {
		if (!quest)
			quest = {
				formId: this.formId,
				formSectionId: this.id,
				tempId: generateUUID(),
				questionDesignId: 1,
				type: "shorttext",
				title: "",
				txt: "",
			};
		let quest_obj = new FormQuestionModel(quest, this);

		if (this.parentForm.curQuestion() && index === null)
		{
			let cur_quest = this.questions(
				this.parentForm.curQuestion().questionId,
				true
			);
			index = cur_quest.position + 1;
		} else if (index === null)
			index = this.questions_.length;
		this.questions_.splice(index + 1, 0, quest_obj);
		this.reorderQuestions();
		return (quest_obj);
	}

	removeQuestion(questId) {
		const idx = this.questions_.findIndex((q) => q.id === questId);
		if (idx !== -1) {
			let quest = this.questions_[idx];
			if (quest.id === this.parentForm.curQuestion()?.id)
				this.parentForm.curQuestion(false);
			let deleted = this.questions_.splice(idx, 1);
			this.reorderQuestions();
			return (deleted);
		}
		return (false);
	}

	cloneQuestion(questId) {
		for (let [idx, q] of this.questions_.entries())
			if (q.id === questId)
			{
				let quest = q.values(true);
				quest.options = quest.options.map((ans, key) => {
					ans.position = key;
					ans.tempId = generateUUID();
					return (ans);
				});
				quest.tempId = generateUUID();
				return (this.addQuestion(quest, idx));
			}
	}

	questions(quest_id, with_index) {
		if (!quest_id)
			return (this.questions_);
		for (let [idx, q] of this.questions_.entries()) {
			if (q.id === quest_id) {
				if (with_index)
					return ({
						index: idx,
						question: q
					});
				else
					return (q);
			}
		}
	}

	order(new_pos) {
		if (new_pos)
			this.position = new_pos;
		return (this.position);
	}

	moveQuestion(from_index, to_index) {
		const [removed] = this.questions_.splice(from_index, 1);
		this.questions_.splice(to_index, 0, removed);
		this.reorderQuestions();
		return (removed);
	}

	reorderQuestions() {
		let pos = 0;
		for (let q of this.questions_)
			q.position = pos++;
	}

	checkValues() {
		if (!this.title?.length)
			return ({
				selector: "[data-form-section-id='" + this.formSectionId+ "']",
				error: "FORM_EMPTY_SECTION_TITLE"
			});
		if (!this.questions_?.length)
			return ({
				selector: "[data-form-section-id='" + this.formSectionId+ "']",
				error: "FORM_NO_SECTION_QUESTION"
			});
		for (let q of this.questions_)
		{
			let check = q.checkValues();
			if (check !== true)
				return ({
					question: q,
					...check
				});
		}
		return (true);
	}

	delete() {
		this.parent.removeSection(this.id);
	}

	setFormId(value) {
		if (value)
		{
			this.formId = value;
			for (let quest of this.questions_)
				quest.setFormId(value);
		}
		return (this.formId);
	}

	get parentForm() {
		return (this.parent);
	}

	get id() {
		return (this.formSectionId ? this.formSectionId : this.tempId);
	}

	set id(value) {
		if (value)
		{
			this.formSectionId = value;
			for (let quest of this.questions_)
				quest.setSectionId(value);
		}
	}

	values() {
		let obj = {
			formId: this.formId,
			tempId: this.tempId,
			title: this.title,
			txt: this.txt,
			position: this.position,
			requiered: this.requiered,
			lastChanged: this.lastChanged,
			lastChangedAuthorId: this.lastChangedAuthorId
		};
		if (this.formSectionId)
			obj.formSectionId = this.formSectionId;
		return (obj);
	}
}
